import { CreateDatasetForm } from '@/components/CreateDatasetForm/CreateDataset.component';
import { type DatasetDetail } from '@/queries/datasets';
import Modal from 'antd/es/modal';
import theme from 'antd/es/theme';

export const CreateDatasetModal = ({
  open,
  teamId,
  onComplete,
  onCancel,
}: {
  open: boolean;
  onCancel?: () => void;
  onComplete?: (dataset: DatasetDetail) => void;
  teamId: string;
}) => {
  const { token } = theme.useToken();
  return (
    <Modal
      title="Create a Dataset"
      open={open}
      onCancel={onCancel}
      footer={null}
      destroyOnHidden
      width={`${token.controlHeightLG * 15}px`}
    >
      <CreateDatasetForm
        teamId={teamId}
        onComplete={onComplete}
        onCancel={onCancel}
      />
    </Modal>
  );
};

export default CreateDatasetModal;
